import { css } from "../utils"

type SvgProps = React.SVGProps<SVGSVGElement>

export const LogoSvg = (props: SvgProps) => (
  <svg
    width="24"
    height="24"
    {...props}
    viewBox="0 0 365 365"
    fill="none"
    stroke="currentColor"
  >
    <g strokeWidth="1" fill="none" fillRule="evenodd">
      <g transform="translate(34.000000, -40.000000)">
        <path
          fill="currentColor"
          d="M176.95459,280.043945 C159.035555,296.545655 141.774823,304.796387 125.171875,304.796387 C111.504814,304.796387 100.166386,300.519167 91.15625,291.9646 C82.1461138,283.410032 77.6411133,272.603093 77.6411133,259.543457 C77.6411133,241.523185 85.2085018,227.679166 100.343506,218.010986 C115.47851,208.342806 137.168316,203.508789 165.413574,203.508789 L172.550781,203.508789 L172.550781,183.615723 C172.550781,164.481838 162.730892,154.915039 143.09082,154.915039 C127.297773,154.915039 110.239512,159.774365 91.9155273,169.493164 L91.9155273,144.740723 C112.061787,136.540486 130.942295,132.44043 148.557617,132.44043 C166.98284,132.44043 180.573768,136.591104 189.330811,144.892578 C198.087853,153.194052 202.466309,166.101638 202.466309,183.615723 L202.466309,258.328613 C202.466309,275.437748 207.730579,283.992188 218.259277,283.992188 C219.575365,283.992188 221.498848,283.789716 224.029785,283.384766 L226.155762,299.937012 C219.37285,303.176611 211.881389,304.796387 203.681152,304.796387 C189.710379,304.796387 180.801614,296.545655 176.95459,280.043945 Z M172.550781,263.79541 L172.550781,221.124023 L162.52832,220.820312 C146.127848,220.820312 132.865936,223.933318 122.742188,230.159424 C112.618439,236.385529 107.556641,244.560333 107.556641,254.684082 C107.556641,261.871943 110.08754,267.946101 115.149414,272.906738 C120.211288,277.867375 126.386682,280.347656 133.675781,280.347656 C146.127992,280.347656 159.086196,274.830296 172.550781,263.79541 Z"
        ></path>
        <path
          id="die"
          d="M155.706934,56.060874 L288.913868,132.967933 C293.554884,135.647425 296.413868,140.59933 296.413868,145.958314 L296.413868,299.772433 C296.413868,305.131417 293.554884,310.083322 288.913868,312.762814 L155.706934,389.669873 C151.065918,392.349365 145.34795,392.349365 140.706934,389.669873 L7.5,312.762814 C2.85898385,310.083322 1.42108547e-13,305.131417 1.42108547e-13,299.772433 L1.42108547e-14,145.958314 C7.10542736e-15,140.59933 2.85898385,135.647425 7.5,132.967933 L140.706934,56.060874 C145.34795,53.381382 151.065918,53.381382 155.706934,56.060874 Z"
          strokeWidth="25"
        ></path>
      </g>
    </g>
  </svg>
)

export const LocationSvg = (props: SvgProps) => (
  <svg
    {...props}
    className={css(props.className, "stroke-current fill-current")}
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 20 20"
  >
    <path d="M10 20S3 10.87 3 7a7 7 0 1 1 14 0c0 3.87-7 13-7 13zm0-11a2 2 0 1 0 0-4 2 2 0 0 0 0 4z" />
  </svg>
)

export const ItalicSvg = (props: SvgProps) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="20"
    height="20"
    {...props}
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="2"
    strokeLinecap="round"
    strokeLinejoin="round"
  >
    <line x1="19" y1="4" x2="10" y2="4" />
    <line x1="14" y1="20" x2="5" y2="20" />
    <line x1="15" y1="4" x2="9" y2="20" />
  </svg>
)

export const CheckMarkSvg = (props: SvgProps) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
    height="24"
    width="24"
    {...props}
    fill="none"
    stroke="currentColor"
    strokeWidth="2"
    strokeLinecap="round"
    strokeLinejoin="round"
  >
    <polyline points="20 6 9 17 4 12" />
  </svg>
)

export const XSvg = (props: SvgProps) => (
  <svg
    width="24"
    height="24"
    {...props}
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="2"
    strokeLinecap="round"
    strokeLinejoin="round"
  >
    <line x1="18" y1="6" x2="6" y2="18" />
    <line x1="6" y1="6" x2="18" y2="18" />
  </svg>
)

export const UnderlineSvg = (props: SvgProps) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="24"
    height="24"
    {...props}
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="2"
    strokeLinecap="round"
    strokeLinejoin="round"
  >
    <path d="M6 3v7a6 6 0 0 0 6 6 6 6 0 0 0 6-6V3" />
    <line x1="4" y1="21" x2="20" y2="21" />
  </svg>
)

export const MinusSvg = (props: SvgProps) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="24"
    height="24"
    {...props}
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="2"
    strokeLinecap="round"
    strokeLinejoin="round"
  >
    <line x1="5" y1="12" x2="19" y2="12"></line>
  </svg>
)

export const LoadingSpinnerSvg = (props: SvgProps) => (
  <svg
    height={16}
    width={16}
    {...props}
    className={css("stroke-current", props.className)}
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 100 100"
    preserveAspectRatio="xMidYMid"
  >
    <circle
      cx="50"
      cy="50"
      fill="none"
      strokeWidth="10"
      r="35"
      strokeDasharray="164.93361431346415 56.97787143782138"
      transform="rotate(246.895 50 50)"
    >
      <animateTransform
        attributeName="transform"
        type="rotate"
        calcMode="linear"
        values="0 50 50;360 50 50"
        keyTimes="0;1"
        dur="1s"
        begin="0s"
        repeatCount="indefinite"
      />
    </circle>
  </svg>
)

export const SquarePlusSvg = (props: SvgProps) => (
  <svg
    height="24"
    width="24"
    {...props}
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="2"
    strokeLinecap="round"
    strokeLinejoin="round"
  >
    <rect x="3" y="3" width="18" height="18" rx="2" ry="2" />
    <line x1="12" y1="8" x2="12" y2="16" />
    <line x1="8" y1="12" x2="16" y2="12" />
  </svg>
)

export const TrashSvg = (props: SvgProps) => (
  <svg
    height="20"
    width="20"
    {...props}
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 1 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="2"
    strokeLinecap="round"
    strokeLinejoin="round"
  >
    <polyline points="3 6 5 6 21 6" />
    <path d="M19 6v14a2 2 0 0 1-2 2H7a2 2 0 0 1-2-2V6m3 0V4a2 2 0 0 1 2-2h4a2 2 0 0 1 2 2v2" />
    <line x1="10" y1="11" x2="10" y2="17" />
    <line x1="14" y1="11" x2="14" y2="17" />
  </svg>
)

export const BoldSvg = (props: SvgProps) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="24"
    height="24"
    {...props}
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="2"
    strokeLinecap="round"
    strokeLinejoin="round"
  >
    <path d="M6 4h8a4 4 0 0 1 4 4 4 4 0 0 1-4 4H6z" />
    <path d="M6 12h9a4 4 0 0 1 4 4 4 4 0 0 1-4 4H6z" />
  </svg>
)

export const MoreHorizontal = (props: SvgProps) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="24"
    height="24"
    {...props}
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="2"
    strokeLinecap="round"
    strokeLinejoin="round"
  >
    <circle cx="12" cy="12" r="1"></circle>
    <circle cx="19" cy="12" r="1"></circle>
    <circle cx="5" cy="12" r="1"></circle>
  </svg>
)

export const PlusSvg = (props: SvgProps) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="24"
    height="24"
    {...props}
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="2"
    strokeLinecap="round"
    strokeLinejoin="round"
  >
    <line x1="12" y1="5" x2="12" y2="19"></line>
    <line x1="5" y1="12" x2="19" y2="12"></line>
  </svg>
)

export const AlertCircle = (props: SvgProps) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="24"
    height="24"
    viewBox="0 0 24 24"
    {...props}
    fill="none"
    stroke="currentColor"
    strokeWidth="2"
    strokeLinecap="round"
    strokeLinejoin="round"
  >
    <circle cx="12" cy="12" r="10" />
    <line x1="12" y1="8" x2="12" y2="12" />
    <line x1="12" y1="16" x2="12" y2="16" />
  </svg>
)

export const CircleSvg = (props: SvgProps) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="24"
    height="24"
    {...props}
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="2"
    strokeLinecap="round"
    strokeLinejoin="round"
  >
    <circle cx="12" cy="12" r="10"></circle>
  </svg>
)

export const CircleCheckSvg = (props: SvgProps) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="24"
    height="24"
    {...props}
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="2"
    strokeLinecap="round"
    strokeLinejoin="round"
  >
    <path d="M22 11.08V12a10 10 0 1 1-5.93-9.14"></path>
    <polyline points="22 4 12 14.01 9 11.01"></polyline>
  </svg>
)

export const ChevronSvg = ({
  ...props
}: SvgProps & { rotate?: 90 | 180 | 270 }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="24"
    height="24"
    {...props}
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="2"
    strokeLinecap="round"
    strokeLinejoin="round"
  >
    <polyline points="6 9 12 15 18 9"></polyline>
  </svg>
)

export const SwordsSvg = (props: SvgProps) => (
  <svg
    height="24"
    width="24"
    {...props}
    fill="currentColor"
    version="1.1"
    x="0px"
    y="0px"
    viewBox="0 0 100 100"
    enableBackground="new 0 0 100 100"
  >
    <path d="M94.199,23.213c0.469-0.469,0.732-1.105,0.732-1.768V7.302c0-1.381-1.119-2.5-2.5-2.5H78.289  c-0.664,0-1.299,0.263-1.768,0.732L50,32.055L23.479,5.534c-0.469-0.469-1.105-0.732-1.768-0.732H7.569c-1.381,0-2.5,1.119-2.5,2.5  v14.142c0,0.664,0.263,1.299,0.732,1.768l26.521,26.521l-9.853,9.853l-1.768-1.768c-1.416-1.417-3.3-2.197-5.303-2.197  s-3.886,0.78-5.303,2.197c-1.417,1.417-2.197,3.3-2.197,5.303c0,2.003,0.78,3.886,2.197,5.303l5.304,5.303L7.266,81.86  c-2.924,2.924-2.924,7.682,0,10.607c1.462,1.461,3.382,2.192,5.303,2.192c1.921,0,3.842-0.731,5.303-2.193l8.132-8.133l5.304,5.304  c1.416,1.417,3.3,2.197,5.303,2.197s3.887-0.779,5.303-2.197c1.417-1.416,2.197-3.3,2.197-5.303s-0.78-3.886-2.197-5.303  l-1.768-1.768l9.853-9.853l9.854,9.854l-1.767,1.767c-1.417,1.416-2.197,3.3-2.197,5.303s0.78,3.886,2.197,5.303  c1.416,1.417,3.3,2.197,5.303,2.197c2.004,0,3.887-0.779,5.303-2.196l5.304-5.304l8.132,8.133c1.462,1.462,3.382,2.192,5.303,2.192  c1.92,0,3.841-0.731,5.303-2.192c1.417-1.416,2.197-3.3,2.197-5.303s-0.78-3.886-2.197-5.303l-8.133-8.133l5.304-5.304  c1.417-1.416,2.197-3.3,2.197-5.303c0-2.003-0.78-3.886-2.197-5.303c-1.417-1.417-3.3-2.197-5.303-2.197s-3.886,0.78-5.303,2.197  l-1.768,1.768l-9.852-9.853L94.199,23.213z M79.324,9.802H89.93v10.607L64.142,46.197L53.536,35.591L79.324,9.802z M14.337,88.93  c-0.975,0.976-2.562,0.975-3.536,0c-0.472-0.472-0.732-1.1-0.732-1.767c0-0.668,0.26-1.296,0.732-1.768l8.132-8.133l3.536,3.536  L14.337,88.93z M38.378,86.103c-0.944,0.944-2.592,0.944-3.536,0l-7.067-7.067c-0.002-0.002-0.003-0.004-0.004-0.005  s-0.004-0.003-0.005-0.004L13.629,64.89c-0.472-0.472-0.732-1.1-0.732-1.768c0-0.668,0.259-1.296,0.732-1.768  c0.473-0.472,1.101-0.732,1.768-0.732c0.668,0,1.296,0.259,1.769,0.732l17.677,17.677c0,0,0,0,0,0.001s0,0,0.001,0l3.534,3.535  c0.472,0.472,0.732,1.1,0.732,1.768C39.11,85.003,38.85,85.631,38.378,86.103z M36.612,73.729L26.004,63.121l9.853-9.853  l10.607,10.607L36.612,73.729z M89.199,85.396c0.975,0.975,0.974,2.562,0,3.536c-0.974,0.974-2.561,0.974-3.536,0l-8.132-8.133  l3.536-3.536L89.199,85.396z M84.603,60.622c0.667,0,1.295,0.258,1.767,0.731c0.472,0.473,0.732,1.101,0.732,1.768  c0,0.668-0.26,1.296-0.732,1.768L65.157,86.102c-0.944,0.944-2.592,0.944-3.536,0c-0.472-0.472-0.732-1.1-0.732-1.768  c0-0.668,0.26-1.296,0.732-1.768l21.214-21.212C83.307,60.882,83.935,60.622,84.603,60.622z M63.389,73.728l-53.32-53.32V9.801  h10.607l53.32,53.32L63.389,73.728z"></path>
  </svg>
)

export const CircleXSvg = (props: SvgProps) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="24"
    height="24"
    {...props}
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="2"
    strokeLinecap="round"
    strokeLinejoin="round"
  >
    <rect x="3" y="3" width="18" height="18" rx="2" ry="2"></rect>
    <line x1="9" y1="9" x2="15" y2="15"></line>
    <line x1="15" y1="9" x2="9" y2="15"></line>
  </svg>
)

export const HeartSvg = (props: SvgProps) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="24"
    height="24"
    {...props}
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="2"
    strokeLinecap="round"
    strokeLinejoin="round"
  >
    <path d="M20.84 4.61a5.5 5.5 0 0 0-7.78 0L12 5.67l-1.06-1.06a5.5 5.5 0 0 0-7.78 7.78l1.06 1.06L12 21.23l7.78-7.78 1.06-1.06a5.5 5.5 0 0 0 0-7.78z"></path>
  </svg>
)

export const SearchSvg = (props: SvgProps) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="24"
    height="24"
    {...props}
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="2"
    strokeLinecap="round"
    strokeLinejoin="round"
  >
    <circle cx="11" cy="11" r="8"></circle>
    <line x1="21" y1="21" x2="16.65" y2="16.65"></line>
  </svg>
)

export const SettingsSvg = (props: SvgProps) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="24"
    height="24"
    {...props}
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="2"
    strokeLinecap="round"
    strokeLinejoin="round"
  >
    <circle cx="12" cy="12" r="3"></circle>
    <path d="M19.4 15a1.65 1.65 0 0 0 .33 1.82l.06.06a2 2 0 0 1 0 2.83 2 2 0 0 1-2.83 0l-.06-.06a1.65 1.65 0 0 0-1.82-.33 1.65 1.65 0 0 0-1 1.51V21a2 2 0 0 1-2 2 2 2 0 0 1-2-2v-.09A1.65 1.65 0 0 0 9 19.4a1.65 1.65 0 0 0-1.82.33l-.06.06a2 2 0 0 1-2.83 0 2 2 0 0 1 0-2.83l.06-.06a1.65 1.65 0 0 0 .33-1.82 1.65 1.65 0 0 0-1.51-1H3a2 2 0 0 1-2-2 2 2 0 0 1 2-2h.09A1.65 1.65 0 0 0 4.6 9a1.65 1.65 0 0 0-.33-1.82l-.06-.06a2 2 0 0 1 0-2.83 2 2 0 0 1 2.83 0l.06.06a1.65 1.65 0 0 0 1.82.33H9a1.65 1.65 0 0 0 1-1.51V3a2 2 0 0 1 2-2 2 2 0 0 1 2 2v.09a1.65 1.65 0 0 0 1 1.51 1.65 1.65 0 0 0 1.82-.33l.06-.06a2 2 0 0 1 2.83 0 2 2 0 0 1 0 2.83l-.06.06a1.65 1.65 0 0 0-.33 1.82V9a1.65 1.65 0 0 0 1.51 1H21a2 2 0 0 1 2 2 2 2 0 0 1-2 2h-.09a1.65 1.65 0 0 0-1.51 1z"></path>
  </svg>
)

export const DragonSvg = (props: SvgProps) => (
  <svg
    height="24"
    width="24"
    {...props}
    fill="currentColor"
    version="1.1"
    viewBox="0 0 847 847"
    x="0px"
    y="0px"
    fillRule="evenodd"
    clipRule="evenodd"
  >
    <defs></defs>
    <g>
      <path d="M426 381c-27,7 -135,84 -135,84l31 -72 104 -12zm140 -169c-197,211 -120,-53 -28,-187 -126,81 -185,252 -185,252l20 -178c-44,37 -84,120 -86,188 -2,68 -51,110 -51,110 -56,234 -148,76 -148,76 -45,179 98,236 98,236 -7,-58 23,-87 23,-87 3,42 28,57 28,57 -11,-31 20,-69 20,-69 0,26 30,34 30,34 28,-167 130,-122 130,-122 48,134 -151,162 -151,162 3,30 38,35 38,35 -24,27 -85,15 -85,15 61,106 181,88 181,88 -73,-91 -22,-148 100,-97 -90,-275 278,-178 278,-178 -148,-82 -246,-136 -25,-232 115,-50 -319,142 -187,-103z" />
    </g>
  </svg>
)

export const DicePlus = (props: SvgProps) => (
  <svg width="24" height="24" {...props} viewBox="0 -10 299 360" version="1.1">
    <g fill="none" transform="translate(2.000000, 2.000000)" strokeWidth="20">
      <path
        d="M155.706934,2.06087397 L288.913868,78.9679332 C293.554884,81.6474251 296.413868,86.5993304 296.413868,91.9583143 L296.413868,245.772433 C296.413868,251.131417 293.554884,256.083322 288.913868,258.762814 L155.706934,335.669873 C151.065918,338.349365 145.34795,338.349365 140.706934,335.669873 L7.5,258.762814 C2.85898385,256.083322 1.42108547e-13,251.131417 1.42108547e-13,245.772433 L1.42108547e-14,91.9583143 C7.10542736e-15,86.5993304 2.85898385,81.6474251 7.5,78.9679332 L140.706934,2.06087397 C145.34795,-0.61861795 151.065918,-0.61861795 155.706934,2.06087397 Z"
        stroke="currentColor"
      ></path>
      <g
        transform="translate(73.000000, 95.000000)"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
      >
        <path d="M75,0 L75,150"></path>
        <path d="M0,75 L150,75"></path>
      </g>
    </g>
  </svg>
)

export const DiceQuestionMark = (props: SvgProps) => (
  <svg
    width="24"
    height="24"
    {...props}
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M10.4048 1.10714L17.5952 5.20729C17.8457 5.35014 18 5.61414 18 5.89985V14.1002C18 14.3859 17.8457 14.6499 17.5952 14.7927L10.4048 18.8929C10.1543 19.0357 9.84568 19.0357 9.59516 18.8929L2.40484 14.7927C2.15432 14.6499 2 14.3859 2 14.1002L2 5.89985C2 5.61414 2.15432 5.35014 2.40484 5.20729L9.59516 1.10714C9.84568 0.964287 10.1543 0.964287 10.4048 1.10714Z"
      stroke="currentColor"
      strokeWidth="2"
    />
    <path
      d="M9.92694 11.5901C9.67647 11.5901 9.49241 11.5115 9.37476 11.3543C9.25712 11.1971 9.20968 10.9976 9.23245 10.7557C9.26281 10.393 9.35009 10.0867 9.49431 9.83676C9.63852 9.58686 9.86622 9.34905 10.1774 9.12334C10.4658 8.89762 10.6784 8.65981 10.815 8.40992C10.9516 8.16002 11.0199 7.88996 11.0199 7.59976C11.0199 7.26925 10.9213 7.00121 10.7239 6.79565C10.5266 6.59008 10.2571 6.4873 9.91556 6.4873C9.65749 6.4873 9.43738 6.53567 9.25522 6.63241C9.07305 6.72914 8.91746 6.87021 8.78843 7.05562C8.66698 7.21685 8.52277 7.3156 8.35579 7.35187C8.1888 7.38815 8.02941 7.37001 7.87761 7.29746C7.64232 7.1846 7.51708 6.99718 7.5019 6.73519C7.48672 6.4732 7.56262 6.24143 7.7296 6.0399C7.98008 5.71745 8.28748 5.46352 8.6518 5.27811C9.01613 5.0927 9.43738 5 9.91556 5C10.7429 5 11.3805 5.24788 11.8283 5.74365C12.2761 6.23942 12.5 6.85006 12.5 7.57557C12.5 8.05119 12.4165 8.48247 12.2495 8.86941C12.0825 9.25635 11.8245 9.60298 11.4753 9.90931C11.2704 10.0947 11.1148 10.264 11.0085 10.4172C10.9023 10.5703 10.8188 10.7437 10.7581 10.9371C10.6594 11.1467 10.5398 11.3079 10.3994 11.4208C10.259 11.5337 10.1015 11.5901 9.92694 11.5901V11.5901ZM9.90417 15C9.62334 15 9.38235 14.8932 9.18121 14.6796C8.98008 14.4659 8.87951 14.214 8.87951 13.9238C8.87951 13.6094 8.98008 13.3474 9.18121 13.1378C9.38235 12.9283 9.62713 12.8235 9.91556 12.8235C10.204 12.8235 10.4469 12.9303 10.6442 13.1439C10.8416 13.3575 10.9402 13.6175 10.9402 13.9238C10.9402 14.214 10.8416 14.4659 10.6442 14.6796C10.4469 14.8932 10.2002 15 9.90417 15V15Z"
      fill="currentColor"
    />
  </svg>
)

export const EditSvg = (props: SvgProps) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="20"
    height="20"
    {...props}
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="2"
    strokeLinecap="round"
    strokeLinejoin="round"
  >
    <path d="M11 4H4a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2v-7"></path>
    <path d="M18.5 2.5a2.121 2.121 0 0 1 3 3L12 15l-4 1 1-4 9.5-9.5z"></path>
  </svg>
)

export const DefaultAvatarSvg = (props: SvgProps) => (
  <svg
    height="24"
    width="24"
    {...props}
    fill="currentColor"
    version="1.1"
    x="0px"
    y="0px"
    viewBox="0 0 100 100"
    enableBackground="new 0 0 100 100"
  >
    <path d="M98.071,88.469c-2.847-6.402-16.743-10.638-25.976-14.615c-9.233-3.977-7.971-6.388-8.303-9.687  c-0.045-0.452-0.075-0.933-0.093-1.426c3.168-2.734,5.76-6.482,7.437-10.809c0,0,0.088-0.22,0.113-0.287  c0.354-0.94,0.668-1.92,0.938-2.919c2.117-0.418,3.35-2.665,3.821-4.743c0.476-0.841,1.465-2.914,1.238-5.266  c-0.292-3.028-1.544-4.427-2.95-5.013c0.002-0.182,0.003-0.355,0.003-0.525c0-3.855-0.367-9.402-1.092-13.048  c-0.155-1.006-0.388-2.019-0.691-3.013c-1.363-4.467-4.214-8.481-8.025-11.304c-3.934-2.913-9.496-4.452-14.437-4.452  c-4.941,0-10.504,1.539-14.437,4.452c-3.811,2.823-6.662,6.837-8.025,11.304c-0.303,0.994-0.536,2.007-0.691,3.013  c-0.725,3.645-1.092,9.191-1.092,13.048c0,0.157,0.001,0.316,0.003,0.482c-1.449,0.559-2.756,1.952-3.056,5.055  c-0.227,2.352,0.762,4.425,1.238,5.266c0.479,2.114,1.747,4.403,3.932,4.763c0.271,1.004,0.59,1.99,0.948,2.938  c0.023,0.062,0.048,0.122,0.072,0.183l0.033,0.082c1.71,4.403,4.369,8.204,7.616,10.946c-0.019,0.439-0.047,0.866-0.088,1.271  c-0.332,3.298,0.639,5.71-8.594,9.687c-9.233,3.977-23.129,8.213-25.976,14.615c-2.847,6.401-1.71,10.168-1.71,10.168h99.547  C99.771,98.636,100.919,94.87,98.071,88.469z" />
  </svg>
)

export const ShieldSvg = (props: SvgProps) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="24"
    height="24"
    {...props}
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="2"
    strokeLinecap="round"
    strokeLinejoin="round"
  >
    <path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z"></path>
  </svg>
)

export const BootSvg = (props: SvgProps) => (
  <svg
    height="24"
    width="24"
    {...props}
    fill="currentColor"
    version="1.1"
    x="0px"
    y="0px"
    viewBox="0 0 100 100"
    strokeWidth="3"
    stroke="currentColor"
    strokeLinecap="round"
    strokeLinejoin="round"
    enableBackground="new 0 0 100 100"
  >
    <g>
      <path d="M35.68,95c0,0-0.001,0-0.002,0c-8.562,0-20.26-1.628-25.049-5.584c-2.655-2.193-4.201-5.223-4.47-8.552   C5.838,76.89,7.44,72.307,10.34,68.993c3.426-3.914,8.631-4.539,15.22-5.293c3.173-0.363,6.77-0.788,10.719-1.629   c9.889-2.104,10.917-10.984,10.955-11.36c0.016-0.157,0.049-0.33,0.094-0.482c1.996-6.631,0.595-19.155-0.428-28.298   c-1.083-9.676-1.374-12.278,0.772-13.57c2.096-1.262,13.811-3.273,23.741-3.273c12.9,0,19.646,3.217,20.052,9.562   c0.492,7.707-1.522,18.714-3.142,27.559c-0.969,5.295-1.806,9.869-1.896,12.467c-0.247,7.157,1.524,19.174,2.482,23.725   c0.803,3.814,0.581,9.111-1.724,12.349c-1.134,1.593-2.678,2.556-4.463,2.782c-4.488,0.569-7.603,0.942-9.909,0.942   c-3.808,0-5.755-1.067-8.616-2.811c-0.761-0.463-1.941-0.698-3.509-0.698c-3.663,0-8.798,1.507-13.763,2.749   C44.188,94.399,40.194,95,35.68,95z M52.186,51.433c-0.522,4.528-4.226,13.252-14.866,15.515   c-4.184,0.891-7.906,1.316-11.191,1.692c-5.732,0.656-9.874,1.13-12.026,3.59c-2.011,2.298-3.173,5.485-2.959,8.12   c0.16,1.978,1.059,3.879,2.67,5.21C16.77,88.002,25.965,90,35.678,90c0,0,0.001,0,0.002,0c4.058,0,7.714-0.557,10.034-1.137   c5.259-1.313,10.697-2.785,14.976-2.785c2.533,0,4.532,0.411,6.11,1.373c2.725,1.659,3.672,2.052,6.015,2.052   c2.013,0,4.981-0.371,9.28-0.917c0.259-0.032,0.608-0.152,1.019-0.729c1.158-1.626,1.555-5.328,0.904-8.422   c-1.033-4.904-2.852-17.254-2.586-24.928c0.102-2.966,0.969-7.707,1.974-13.196c1.569-8.576,3.522-19.248,3.069-26.342   c-0.194-3.056-5.825-4.881-15.062-4.881c-8.636,0-17.376,1.513-20.347,2.312c-0.002,1.779,0.422,5.565,0.803,8.974   C52.93,30.848,54.378,43.789,52.186,51.433z"></path>
    </g>
  </svg>
)

export const WeightSvg = (props: SvgProps) => (
  <svg
    width="24"
    height="24"
    {...props}
    viewBox="0 0 100 100"
    version="1.1"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g id="Page-1" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
      <g id="noun_Weight_1528288" fill="currentColor" fillRule="nonzero">
        <path d="M86.7282262,26.0211076 L72.5490196,26.0211076 C72.6880985,24.7524752 72.6880985,23.8570341 72.6880985,21.6537918 C72.6880985,9.71385051 62.5102599,0 50,0 C37.4897401,0 27.3119015,9.71385051 27.3119015,21.6537918 C27.3119015,23.8581221 27.3119015,23.8581221 27.4509804,26.0211076 L12.2902417,26.0211076 L0.67373461,100 L99.3251254,100 L87.1864677,29.6663438 L86.7282262,26.0211076 Z M33.79845,20.8324258 C33.79845,12.189215 41.1663338,5.15721881 50.2223929,5.15721881 C59.278452,5.15721881 66.6463358,12.189215 66.6463358,20.8324258 C66.6463358,22.8201107 66.2529051,24.7580547 65.4752408,26.6101713 L34.969545,26.6101713 C34.1918807,24.75903 33.79845,22.8201107 33.79845,20.8324258 Z M18.1383949,32.2663475 L81.8616051,32.2663475 L92.0907433,93.7547601 L7.90925673,93.7547601 L18.1383949,32.2663475 Z"></path>
      </g>
    </g>
  </svg>
)

export const MenuSvg = (props: SvgProps) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="24"
    height="24"
    {...props}
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="2"
    strokeLinecap="round"
    strokeLinejoin="round"
  >
    <line x1="3" y1="6" x2="19" y2="6"></line>
    <line x1="3" y1="12" x2="21" y2="12"></line>
    <line x1="3" y1="18" x2="17" y2="18"></line>
  </svg>
)

export const ImageSvg = (props: SvgProps) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="24"
    height="24"
    {...props}
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="2"
    strokeLinecap="round"
    strokeLinejoin="round"
  >
    <rect x="3" y="3" width="18" height="18" rx="2" ry="2"></rect>
    <circle cx="8.5" cy="8.5" r="1.5"></circle>
    <polyline points="21 15 16 10 5 21"></polyline>
  </svg>
)

export const LightBulbSvg = (props: SvgProps) => (
  <svg width="16px" height="16" {...props} viewBox="0 0 16 20" version="1.1">
    <g stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
      <g id="noun_lightbulb_1247022" fill="currentColor" fillRule="nonzero">
        <path d="M13,2.16 C10.8614635,0.249811355 7.82094646,-0.273857243 5.16659831,0.810852337 C2.51225016,1.89556192 0.708683593,4.39878392 0.52,7.26 C0.323366729,9.93751277 1.58450489,12.5132919 3.82,14 C4.02266782,14.1309621 4.15222379,14.3493564 4.17,14.59 L4.38,18 C4.44314353,18.9873149 5.26067332,19.7567547 6.25,19.76 L9.76,19.76 C10.7493267,19.7567547 11.5668565,18.9873149 11.63,18 L11.84,14.58 C11.8600364,14.3374988 11.9935178,14.1187377 12.2,13.99 C14.1249363,12.696398 15.3431226,10.5850207 15.4996018,8.27108465 C15.656081,5.95714856 14.7332482,3.70098557 13,2.16 Z M10.24,16 L5.76,16 L5.76,15.25 L10.33,15.25 L10.24,16 Z M9.75,18.25 L6.25,18.25 C6.05516273,18.2454755 5.89533351,18.0942857 5.88,17.9 L5.88,17.5 L10.18,17.5 L10.18,17.9 C10.1726556,18.0047753 10.1222724,18.1018381 10.0408133,18.168142 C9.95935411,18.234446 9.85408481,18.2640772 9.75,18.25 Z M11.34,12.73 C10.9725704,12.9761878 10.6842936,13.3235092 10.51,13.73 L5.51,13.73 C5.33620148,13.3232067 5.04781823,12.975757 4.68,12.73 C2.88806822,11.5456552 1.86593598,9.49376282 2,7.35 C2.19334798,4.46047073 4.42303385,2.12140404 7.3,1.79 C7.53315359,1.77704761 7.76684641,1.77704761 8,1.79 C9.4773713,1.78391938 10.9038087,2.32953168 12,3.32 C13.3801089,4.55434884 14.1130179,6.35674789 13.9859613,8.20395501 C13.8589047,10.0511621 12.8861165,11.7362381 11.35,12.77 L11.34,12.73 Z"></path>
      </g>
    </g>
  </svg>
)

export const ToggleLeft = (props: SvgProps) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="24"
    height="24"
    {...props}
    viewBox="0 0 24 24"
    fill="none"
    stroke="none"
    strokeWidth="2"
    strokeLinecap="round"
    strokeLinejoin="round"
  >
    <rect x="1" y="5" width="22" height="14" rx="7" ry="7"></rect>
    <circle
      stroke="currentColor"
      fill="currentColor"
      cx="8"
      cy="12"
      r="3"
    ></circle>
  </svg>
)

export const ToggleRight = (props: SvgProps) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="24"
    height="24"
    {...props}
    viewBox="0 0 24 24"
    fill="none"
    stroke="none"
    strokeWidth="2"
    strokeLinecap="round"
    strokeLinejoin="round"
  >
    <rect x="1" y="5" width="22" height="14" rx="7" ry="7"></rect>
    <circle
      stroke="currentColor"
      fill="currentColor"
      cx="16"
      cy="12"
      r="3"
    ></circle>
  </svg>
)

export const CopySvg = (props: SvgProps) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="24"
    height="24"
    {...props}
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="2"
    strokeLinecap="round"
    strokeLinejoin="round"
  >
    <rect x="9" y="9" width="13" height="13" rx="2" ry="2"></rect>
    <path d="M5 15H4a2 2 0 0 1-2-2V4a2 2 0 0 1 2-2h9a2 2 0 0 1 2 2v1"></path>
  </svg>
)

export const MapSvg = (props: SvgProps) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="24"
    height="24"
    {...props}
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="2"
    strokeLinecap="round"
    strokeLinejoin="round"
  >
    <polygon points="1 6 1 22 8 18 16 22 23 18 23 2 16 6 8 2 1 6"></polygon>
    <line x1="8" y1="2" x2="8" y2="18"></line>
    <line x1="16" y1="6" x2="16" y2="22"></line>
  </svg>
)

export const FileTextSvg = (props: SvgProps) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="24"
    height="24"
    {...props}
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="2"
    strokeLinecap="round"
    strokeLinejoin="round"
  >
    <path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z"></path>
    <polyline points="14 2 14 8 20 8"></polyline>
    <line x1="16" y1="13" x2="8" y2="13"></line>
    <line x1="16" y1="17" x2="8" y2="17"></line>
    <polyline points="10 9 9 9 8 9"></polyline>
  </svg>
)

export const OrderedListSvg = (props: SvgProps) => (
  <svg
    {...props}
    fill="currentColor"
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
  >
    <path d="M8 7h12c.55 0 1-.45 1-1s-.45-1-1-1H8c-.55 0-1 .45-1 1s.45 1 1 1zm12 10H8c-.55 0-1 .45-1 1s.45 1 1 1h12c.55 0 1-.45 1-1s-.45-1-1-1zm0-6H8c-.55 0-1 .45-1 1s.45 1 1 1h12c.55 0 1-.45 1-1s-.45-1-1-1zM4.5 16h-2c-.28 0-.5.22-.5.5s.22.5.5.5H4v.5h-.5c-.28 0-.5.22-.5.5s.22.5.5.5H4v.5H2.5c-.28 0-.5.22-.5.5s.22.5.5.5h2c.28 0 .5-.22.5-.5v-3c0-.28-.22-.5-.5-.5zm-2-11H3v2.5c0 .28.22.5.5.5s.5-.22.5-.5v-3c0-.28-.22-.5-.5-.5h-1c-.28 0-.5.22-.5.5s.22.5.5.5zm2 5h-2c-.28 0-.5.22-.5.5s.22.5.5.5h1.3l-1.68 1.96c-.08.09-.12.21-.12.32v.22c0 .28.22.5.5.5h2c.28 0 .5-.22.5-.5s-.22-.5-.5-.5H3.2l1.68-1.96c.08-.09.12-.21.12-.32v-.22c0-.28-.22-.5-.5-.5z" />
  </svg>
)

export const UnorderedListSvg = (props: SvgProps) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    height="24"
    viewBox="0 0 24 24"
    fill="currentColor"
    width="24"
    {...props}
  >
    <path d="M0 0h24v24H0V0z" fill="none" />
    <path d="M4 10.5c-.83 0-1.5.67-1.5 1.5s.67 1.5 1.5 1.5 1.5-.67 1.5-1.5-.67-1.5-1.5-1.5zm0-6c-.83 0-1.5.67-1.5 1.5S3.17 7.5 4 7.5 5.5 6.83 5.5 6 4.83 4.5 4 4.5zm0 12c-.83 0-1.5.68-1.5 1.5s.68 1.5 1.5 1.5 1.5-.68 1.5-1.5-.67-1.5-1.5-1.5zM8 19h12c.55 0 1-.45 1-1s-.45-1-1-1H8c-.55 0-1 .45-1 1s.45 1 1 1zm0-6h12c.55 0 1-.45 1-1s-.45-1-1-1H8c-.55 0-1 .45-1 1s.45 1 1 1zM7 6c0 .55.45 1 1 1h12c.55 0 1-.45 1-1s-.45-1-1-1H8c-.55 0-1 .45-1 1z" />
  </svg>
)

export const GridSvg = (props: SvgProps) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="24"
    height="24"
    {...props}
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="2"
    strokeLinecap="round"
    strokeLinejoin="round"
  >
    <rect x="3" y="3" width="7" height="7"></rect>
    <rect x="14" y="3" width="7" height="7"></rect>
    <rect x="14" y="14" width="7" height="7"></rect>
    <rect x="3" y="14" width="7" height="7"></rect>
  </svg>
)

export const RemoveRowSvg = (props: SvgProps) => (
  <svg width="24" height="24" {...props} viewBox="0 0 24 24" version="1.1">
    <g
      stroke="currentColor"
      strokeWidth="1"
      fill="currentColor"
      fillRule="evenodd"
    >
      <g
        strokeWidth="2"
        transform="translate(1.000000, 7.000000)"
        strokeLinecap="round"
        strokeLinejoin="round"
      >
        <path d="M5,0 L0,5"></path>
        <path d="M0,0 L5,5"></path>
      </g>
      <g transform="translate(8.000000, 1.000000)" fillRule="nonzero">
        <path d="M13.8157895,6 L1.18421053,6 C0.531315789,6 0,5.327 0,4.5 L0,1.5 C0,0.673 0.531315789,0 1.18421053,0 L13.8157895,0 C14.4686842,0 15,0.673 15,1.5 L15,4.5 C15,5.327 14.4686842,6 13.8157895,6 Z M1.18421053,1 C0.967105263,1 0.789473684,1.224 0.789473684,1.5 L0.789473684,4.5 C0.789473684,4.776 0.967105263,5 1.18421053,5 L13.8157895,5 C14.0328947,5 14.2105263,4.776 14.2105263,4.5 L14.2105263,1.5 C14.2105263,1.224 14.0328947,1 13.8157895,1 L1.18421053,1 Z"></path>
        <path d="M13.8157895,22 L1.18421053,22 C0.531315789,22 0,21.327 0,20.5 L0,12.5 C0,11.673 0.531315789,11 1.18421053,11 L13.8157895,11 C14.4686842,11 15,11.673 15,12.5 L15,20.5 C15,21.327 14.4686842,22 13.8157895,22 Z M1.18421053,12 C0.967105263,12 0.789473684,12.224 0.789473684,12.5 L0.789473684,20.5 C0.789473684,20.776 0.967105263,21 1.18421053,21 L13.8157895,21 C14.0328947,21 14.2105263,20.776 14.2105263,20.5 L14.2105263,12.5 C14.2105263,12.224 14.0328947,12 13.8157895,12 L1.18421053,12 Z"></path>
        <path d="M14.6052632,17 L0.394736842,17 C0.176842105,17 0,16.776 0,16.5 C0,16.224 0.176842105,16 0.394736842,16 L14.6052632,16 C14.8231579,16 15,16.224 15,16.5 C15,16.776 14.8231579,17 14.6052632,17 Z"></path>
      </g>
    </g>
  </svg>
)

export const InsertRowSvg = (props: SvgProps) => (
  <svg width="24" height="24" {...props} viewBox="0 0 24 24" version="1.1">
    <g
      stroke="currentColor"
      strokeWidth="1"
      fill="currentColor"
      fillRule="evenodd"
    >
      <g transform="translate(1.000000, 4.000000)" fillRule="nonzero">
        <path d="M0.5,10.3181826 C0.436,10.3181826 0.37,10.3050917 0.309,10.2767281 C0.122,10.1927281 0,9.99309171 0,9.77272808 L0,1.04545535 C0,0.825091714 0.122,0.62545535 0.309,0.54145535 C0.495,0.45745535 0.711,0.503273532 0.854,0.659273532 L4.854,5.0229099 C5.049,5.23563717 5.049,5.58145535 4.854,5.79418262 L0.854,10.157819 C0.758,10.2625463 0.63,10.3181826 0.5,10.3181826 Z M1,2.36218262 L1,8.4560008 L3.793,5.40909171 L1,2.36218262 Z"></path>
      </g>
      <g transform="translate(6.000000, 1.000000)" fillRule="nonzero">
        <path d="M15.6578947,6 L1.34210526,6 C0.602157895,6 0,5.327 0,4.5 L0,1.5 C0,0.673 0.602157895,0 1.34210526,0 L15.6578947,0 C16.3978421,0 17,0.673 17,1.5 L17,4.5 C17,5.327 16.3978421,6 15.6578947,6 Z M1.34210526,1 C1.09605263,1 0.894736842,1.224 0.894736842,1.5 L0.894736842,4.5 C0.894736842,4.776 1.09605263,5 1.34210526,5 L15.6578947,5 C15.9039474,5 16.1052632,4.776 16.1052632,4.5 L16.1052632,1.5 C16.1052632,1.224 15.9039474,1 15.6578947,1 L1.34210526,1 Z"></path>
        <path d="M15.6578947,22 L1.34210526,22 C0.602157895,22 0,21.327 0,20.5 L0,12.5 C0,11.673 0.602157895,11 1.34210526,11 L15.6578947,11 C16.3978421,11 17,11.673 17,12.5 L17,20.5 C17,21.327 16.3978421,22 15.6578947,22 Z M1.34210526,12 C1.09605263,12 0.894736842,12.224 0.894736842,12.5 L0.894736842,20.5 C0.894736842,20.776 1.09605263,21 1.34210526,21 L15.6578947,21 C15.9039474,21 16.1052632,20.776 16.1052632,20.5 L16.1052632,12.5 C16.1052632,12.224 15.9039474,12 15.6578947,12 L1.34210526,12 Z"></path>
        <path d="M16.5526316,17 L0.447368421,17 C0.200421053,17 0,16.776 0,16.5 C0,16.224 0.200421053,16 0.447368421,16 L16.5526316,16 C16.7995789,16 17,16.224 17,16.5 C17,16.776 16.7995789,17 16.5526316,17 Z"></path>
      </g>
    </g>
  </svg>
)

export const BlockquoteSvg = (props: SvgProps) => (
  <svg
    height="24"
    width="24"
    {...props}
    fill="currentColor"
    xmlns="http://www.w3.org/2000/svg"
    version="1.1"
    x="0px"
    y="0px"
    viewBox="0 0 100 100"
  >
    <g>
      <g>
        <g>
          <path d="M5273.1,2400.1v-2c0-2.8-5-4-9.7-4s-9.7,1.3-9.7,4v2c0,1.8,0.7,3.6,2,4.9l5,4.9c0.3,0.3,0.4,0.6,0.4,1v6.4     c0,0.4,0.2,0.7,0.6,0.8l2.9,0.9c0.5,0.1,1-0.2,1-0.8v-7.2c0-0.4,0.2-0.7,0.4-1l5.1-5C5272.4,2403.7,5273.1,2401.9,5273.1,2400.1z      M5263.4,2400c-4.8,0-7.4-1.3-7.5-1.8v0c0.1-0.5,2.7-1.8,7.5-1.8c4.8,0,7.3,1.3,7.5,1.8C5270.7,2398.7,5268.2,2400,5263.4,2400z"></path>
          <path d="M5268.4,2410.3c-0.6,0-1,0.4-1,1c0,0.6,0.4,1,1,1h4.3c0.6,0,1-0.4,1-1c0-0.6-0.4-1-1-1H5268.4z"></path>
          <path d="M5272.7,2413.7h-4.3c-0.6,0-1,0.4-1,1c0,0.6,0.4,1,1,1h4.3c0.6,0,1-0.4,1-1C5273.7,2414.1,5273.3,2413.7,5272.7,2413.7z"></path>
          <path d="M5272.7,2417h-4.3c-0.6,0-1,0.4-1,1c0,0.6,0.4,1,1,1h4.3c0.6,0,1-0.4,1-1C5273.7,2417.5,5273.3,2417,5272.7,2417z"></path>
        </g>
        <g>
          <path d="M23.7,17C12,17,2.5,26.5,2.5,38.3c0,11.1,8.5,20.1,19.3,21.1c-2.2,4-6.2,8.3-13,12.4c-1.9,1.1-3.1,3.1-3.1,5.2     c0,4.3,4.4,7.3,8.4,5.5C25.7,77.3,45,64.6,45,38.3C45,26.5,35.5,17,23.7,17z"></path>
          <path d="M76.3,17C64.5,17,55,26.5,55,38.3c0,11.1,8.5,20.1,19.3,21.1c-2.2,4-6.2,8.3-13,12.4c-1.9,1.1-3.1,3.1-3.1,5.2     c0,4.3,4.4,7.3,8.4,5.5c11.5-5.2,30.8-17.8,30.8-44.2C97.5,26.5,88,17,76.3,17z"></path>
        </g>
      </g>
    </g>
  </svg>
)

export const RotateSvg = (props: SvgProps) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="24"
    height="24"
    {...props}
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="2"
    strokeLinecap="round"
    strokeLinejoin="round"
  >
    <polyline points="1 4 1 10 7 10"></polyline>
    <path d="M3.51 15a9 9 0 1 0 2.13-9.36L1 10"></path>
  </svg>
)

export const ClockSvg = (props: SvgProps) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="24"
    height="24"
    {...props}
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="2"
    strokeLinecap="round"
    strokeLinejoin="round"
  >
    <circle cx="12" cy="12" r="10"></circle>
    <polyline points="12 6 12 12 16 14"></polyline>
  </svg>
)

export const TargetSvg = (props: SvgProps) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="24"
    height="24"
    {...props}
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="2"
    strokeLinecap="round"
    strokeLinejoin="round"
  >
    <circle cx="12" cy="12" r="10"></circle>
    <circle cx="12" cy="12" r="6"></circle>
    <circle cx="12" cy="12" r="2"></circle>
  </svg>
)

export const DurationSvg = (props: SvgProps) => (
  <svg
    height="24"
    width="24"
    {...props}
    fill="currentColor"
    y="0px"
    viewBox="0 0 100 100"
  >
    <g>
      <g>
        <g>
          <path d="M5273.1,2400.1v-2c0-2.8-5-4-9.7-4s-9.7,1.3-9.7,4v2c0,1.8,0.7,3.6,2,4.9l5,4.9c0.3,0.3,0.4,0.6,0.4,1v6.4     c0,0.4,0.2,0.7,0.6,0.8l2.9,0.9c0.5,0.1,1-0.2,1-0.8v-7.2c0-0.4,0.2-0.7,0.4-1l5.1-5C5272.4,2403.7,5273.1,2401.9,5273.1,2400.1z      M5263.4,2400c-4.8,0-7.4-1.3-7.5-1.8v0c0.1-0.5,2.7-1.8,7.5-1.8c4.8,0,7.3,1.3,7.5,1.8C5270.7,2398.7,5268.2,2400,5263.4,2400z"></path>
          <path d="M5268.4,2410.3c-0.6,0-1,0.4-1,1c0,0.6,0.4,1,1,1h4.3c0.6,0,1-0.4,1-1c0-0.6-0.4-1-1-1H5268.4z"></path>
          <path d="M5272.7,2413.7h-4.3c-0.6,0-1,0.4-1,1c0,0.6,0.4,1,1,1h4.3c0.6,0,1-0.4,1-1C5273.7,2414.1,5273.3,2413.7,5272.7,2413.7z"></path>
          <path d="M5272.7,2417h-4.3c-0.6,0-1,0.4-1,1c0,0.6,0.4,1,1,1h4.3c0.6,0,1-0.4,1-1C5273.7,2417.5,5273.3,2417,5272.7,2417z"></path>
        </g>
        <g>
          <path d="M92.5,37.7c2.8,0,5-2.2,5-5V10.4c0-2.8-2.2-5-5-5c-2.8,0-5,2.2-5,5v10.3l-4.2-4.2c-9-8.9-20.8-13.9-33.5-13.9     c-12.7,0-24.6,4.9-33.5,13.9C-2.1,35-2.1,65,16.4,83.5c9.2,9.2,21.4,13.9,33.5,13.9c12.1,0,24.3-4.6,33.5-13.9     c7.3-7.3,12-16.7,13.4-26.9c0.4-2.7-1.5-5.2-4.3-5.6c-2.7-0.4-5.2,1.5-5.6,4.3c-1.1,8.1-4.8,15.4-10.6,21.2     C61.7,91,38,91,23.4,76.5c-14.6-14.6-14.6-38.3,0-52.9c7.1-7.1,16.5-11,26.4-11c10,0,19.4,3.9,26.4,11l4.2,4.2H70.2     c-2.8,0-5,2.2-5,5s2.2,5,5,5H92.5z"></path>
          <path d="M49.6,23.7c-2.8,0-5,2.2-5,5V50c0,1.7,0.8,3.2,2.2,4.1l12.8,8.6c0.9,0.6,1.8,0.9,2.8,0.9c1.6,0,3.2-0.8,4.1-2.2     c1.5-2.3,0.9-5.4-1.3-6.9l-10.6-7.1V28.7C54.6,26,52.4,23.7,49.6,23.7z"></path>
        </g>
      </g>
    </g>
  </svg>
)

export const BattleAxeSvg = (props: SvgProps) => (
  <svg
    height="24"
    width="24"
    {...props}
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 512 512"
  >
    <path d="M0 0h512v512H0z" fill="#ff2020" fill-opacity="0"></path>
    <g>
      <path
        d="M240.094 19.594c-56.69.364-110.882 29.054-151.594 72.344-53.428 56.81-81.948 137.907-61.03 210.093 16.33-8.797 32.757-15.987 48.936-21.374-6.327-123.16 89.247-210.922 200.03-210.344 4.255-13.365 10.268-27.308 18.127-41.874-16.323-5.43-32.736-8.36-48.97-8.782-1.833-.047-3.67-.074-5.5-.062zM271.28 88.97C173.724 90.715 91.367 166.07 94.907 275.28c10.986-2.73 21.788-4.582 32.28-5.436 14.59-1.187 28.69-.463 41.783 2.437L278.312 162.94c-5.26-12.1-8.473-25.024-9.344-38.75-.716-11.256.14-22.983 2.592-35.22-.093.002-.187 0-.28 0zm60.845 60.718l-16.875 16.875L345.75 197l16.813-16.813-30.438-30.5zm-37.125 23L175.625 292.063l44.625 44.562 119.313-119.313L295 172.688zm189.875 46.093c-14.466 7.808-28.318 13.807-41.594 18.064.75 111.013-87.243 206.8-210.686 200.28-5.39 16.104-12.552 32.462-21.313 48.72 72.19 20.922 153.313-7.6 210.126-61.03 57.045-53.65 88.516-130.72 63.47-206.033zm-136 15.657L240.687 342.625c3.23 13.563 4.086 28.245 2.844 43.47-.862 10.58-2.752 21.476-5.53 32.56 109.585 3.718 185.128-79.008 186.594-176.905-12.342 2.506-24.16 3.403-35.5 2.688-14.287-.9-27.698-4.347-40.22-10zM169.5 312.313L20.094 461.72V494H48.75l151.188-151.188-30.438-30.5z"
        fill="currentColor"
        fillOpacity="1"
      ></path>
    </g>
  </svg>
)

export const LyreSvg = (props: SvgProps) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 512 512"
    height={24}
    width={24}
    {...props}
  >
    <g>
      <path
        d="M108.656 35.063c-15.053.138-33.413 5.378-46.97 15.812-10.75 8.276-18.777 19.27-21.186 34.438.21-.126.414-.252.625-.376-.843 2.816-1.313 5.786-1.313 8.876 0 17.087 13.85 30.937 30.938 30.937 14.293 0 26.324-9.705 29.875-22.875.028-.115.067-.23.094-.344.48-2.082.768-4.042.905-5.843.025-.327.017-.65.03-.968.005-.126.03-.25.032-.376.007-.182-.002-.353 0-.53 0-1.526-.098-3.036-.312-4.5-1.367-8.018-6.778-12.156-12.594-13.72-8.527-2.293-19.055.637-23.75 18.156l-.468-.125C62.04 74.12 72.213 63.885 83.94 60.78c2.476-.654 5.053-1.005 7.656-.968 9.072.13 18.445 4.88 24.562 17.126.087.173.165.355.25.53 5.208 15.233 2.11 43.32-3.344 57.626-7.288 18.753-22.376 40.504-47.687 65.5C6.99 258.252 4 329.824 39.97 388.814 75.936 447.8 152.13 493.56 254.437 493.56c102.306 0 178.47-45.76 214.437-104.75 35.882-58.848 32.982-130.225-25-187.812l-.406-.406h-.033c-25.31-24.996-40.367-46.747-47.656-65.5-5.23-16.453-9.09-42.988-2.655-57.625.058-.128.128-.25.188-.376.025-.05.037-.106.062-.156 6.117-12.246 15.49-16.996 24.563-17.126 2.602-.037 5.18.314 7.656.97 11.724 3.102 21.87 13.337 19.344 32.843l-.438.125c-4.694-17.52-15.222-20.45-23.75-18.156-4.41 1.185-8.603 3.85-10.97 8.562-.012.04-.017.085-.03.125-.975 3.007-1.5 6.203-1.5 9.532 0 17.088 13.85 30.938 30.938 30.938 17.087 0 30.937-13.85 30.937-30.938 0-4.355-.907-8.49-2.53-12.25-3.058-13.244-10.598-23.112-20.44-30.687-14.458-11.13-34.39-16.363-49.936-15.78-13.378.5-24.85 4.108-33.22 10.53-3.412 2.617-6.383 5.702-8.844 9.375-69.455 35.508-138.89 38.75-208.344-7.75-.642-.557-1.29-1.105-1.968-1.625-8.37-6.422-19.843-10.03-33.22-10.53-.97-.037-1.964-.042-2.968-.032zm52.78 53.124c6.338 2.648 12.666 4.987 19 7.032v313.06c-30.732-8.258-57.886-22.005-77.374-41.31-17.1-16.94-28.077-38.626-28.906-63.595-.828-24.97 8.274-52.702 28.97-82.625 41.323-59.752 57.163-103.6 58.31-132.563zm186.033 1.407c1.6 28.97 17.593 72.37 58.25 131.156 20.693 29.923 29.796 57.656 28.967 82.625-.828 24.97-11.807 46.654-28.906 63.594-19.023 18.846-45.374 32.4-75.217 40.717V94.844c5.636-1.606 11.27-3.35 16.906-5.25zm-35.595 10v312.53c-8.21 1.63-16.606 2.878-25.125 3.782V104.094c8.376-1.122 16.75-2.63 25.125-4.5zm-112.75.78c8.45 1.97 16.894 3.442 25.344 4.44v311.342c-8.59-.84-17.057-2.05-25.345-3.625V100.376zm68.938 5.564v311.375c-4.54.198-9.088.312-13.657.312-3.76 0-7.506-.053-11.25-.188V106.28c8.293.314 16.614.18 24.906-.343z"
        fill="currentColor"
      ></path>
    </g>
  </svg>
)

export const WarlockEyeSvg = (props: SvgProps) => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512" {...props}>
    <g>
      <path
        d="M256 16l-32 112 32 32 32-32-32-112zM64 96l32 80 64 16-96-96zm384 0l-96 96 64-16 32-80zm-192 80l-64 48-128 32c80 16 128 96 192 128 64-32 112.476-110.213 192-128l-128-28.31L256 176zm-39.512 52.682l28.342 8.863-7.45 20.955L256 310.895l18.62-52.395-7.45-20.955 28.342-8.863c14.923 10.97 24.488 28.03 24.488 47.283C320 309.237 291.47 336 256 336s-64-26.763-64-60.035c0-19.254 9.565-36.314 24.488-47.283zM96 336l-64 48-16 64 32-32 64-48s-16-27.61-16-32zm320 0l-16 32 64 48 32 32-16-64-64-48zm-272 64l-16 64 48-48-32-16zm112 0l-48 16 48 80 48-80-48-16zm112 0l-32 16 48 48-16-64z"
        fill="currentColor"
      ></path>
    </g>
  </svg>
)

export const FistSvg = (props: SvgProps) => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512" {...props}>
    <g>
      <path
        d="M329.8 235.69l62.83-82.71 42.86 32.56-62.83 82.75zm-12.86-9.53l66.81-88-45-34.15-66.81 88zm-27.48-97.78l-19.3 39.57 57-75-42.51-32.3-36.24 47.71zm-20.74-73.24l-46.64-35.43-42 55.31 53.67 26.17zm107 235.52l-139-102.71-9.92.91 4.56 2 62.16 138.43-16.52 2.25-57.68-128.5-40-17.7-4-30.84 39.41 19.42 36.36-3.33 17-34.83-110.9-54.09-80.68 112.51L177.6 346.67l-22.7 145.62H341V372.62l35.29-48.93L387 275.77z"
        fill="currentColor"
      ></path>
    </g>
  </svg>
)

export const CrossShield = (props: SvgProps) => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512" {...props}>
    <g>
      <path
        d="M256 20c-64 96-128 88-192 104 0 256 64 320 192 368 128-48 192-112 192-368-64-16-128-8-192-104zm0 32a9 9 0 1 1 0 18 9 9 0 0 1 0-18zm.291 30.152a269.17 269.17 0 0 0 13.84 14.15c34.949 35.385 82.966 45.887 130.685 56.428 2.732 1.184 6.62.508 8.864 1.958-2.683 64.84-5.522 131.649-32.315 191.746-12.685 31.46-36.26 57.602-64.37 76.144-15.452 10.864-32.847 18.227-49.884 26.115-6.586 4.573-13.697-.448-20.242-2.46-43.648-17.847-84.444-48.619-105.056-92.266-29.065-62.018-32.949-131.823-35.815-199.393 57.423-8.808 112.578-27.8 152.441-70.418zM256 124l-27.512 68.78C211.228 189.067 190.45 182.15 160 172c0 32-16 48-32 64 0 16 64 32 80 32 13.173-8.782 22.72-15.138 30.646-19.1C234.19 277.441 218.65 337.35 192 364c32 16 48 32 64 48 16-16 32-32 64-48-26.65-26.65-42.19-86.559-46.646-115.1 7.926 3.962 17.473 10.318 30.646 19.1 16 0 80-16 80-32-16-16-32-32-32-64-30.45 10.15-51.228 17.068-68.488 20.78zm-172 8a9 9 0 1 1 0 18 9 9 0 0 1 0-18zm344 0a9 9 0 1 1 0 18 9 9 0 0 1 0-18zM96 282a9 9 0 1 1 0 18 9 9 0 0 1 0-18zm320 0a9 9 0 1 1 0 18 9 9 0 0 1 0-18zM160 410a9 9 0 1 1 0 18 9 9 0 0 1 0-18zm192 0a9 9 0 1 1 0 18 9 9 0 0 1 0-18zm-96 50a9 9 0 1 1 0 18 9 9 0 0 1 0-18z"
        fill="currentColor"
        fill-opacity="1"
      ></path>
    </g>
  </svg>
)

export const HammerSvg = (props: SvgProps) => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512" {...props}>
    <g>
      <path
        d="M266.033 32.42l-85.238 85.238v19.799L285.832 32.42h-19.799zm41.528 3.728L184.523 159.186l168.291 168.29L475.852 204.44 307.56 36.15zm172.02 190.02L374.542 331.205h19.799l85.238-85.238v-19.799zm-239.903 13.627l-9.9 9.9 32.527 32.528 9.9-9.9-32.527-32.528zm-22.627 22.627l-23.528 23.527h47.055l-23.527-23.527zm-41.528 41.527l-27.255 27.256h65.054l27.256-27.256h-65.055zm-45.255 45.256l-27.254 27.254h65.054l27.254-27.254h-65.054zm-27.254 45.254l23.527 23.527 23.527-23.527h-47.054zm-21.729 3.728l-9.898 9.899 32.527 32.527 9.898-9.898-32.527-32.527zm-38.767 18.899l-7.504 22.512 37.388 37.388 22.512-7.504v-12.414L54.93 417.086H42.518z"
        fill="currentColor"
      ></path>
    </g>
  </svg>
)

export const FlameSvg = (props: SvgProps) => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512" {...props}>
    <g>
      <path
        d="M166 121c0 90 90 105 90 180 0 30-30 75-75 75s-75-45-45-120c-45 30-60 60-60 90 0 75 75 150 180 150s180-45 180-135c.67-133.125-153.4-177.596-195-240-30-45-15-75 15-105-60 15-90 57-90 105z"
        fill="currentColor"
      ></path>
    </g>
  </svg>
)

export const DaggersSvg = (props: SvgProps) => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512" {...props}>
    <g>
      <path
        d="M233.56 16.225l-15.535 54.302-79.183-12.79-2.98 18.45L212.85 88.62l-14.92 52.163 17.968 5.14 11.028-38.546c92.558 14.84 177.404 26.687 273.004 16.824-78.98-39.333-166.495-51.603-258.832-66.368l10.43-36.467-17.97-5.14zm-68.695 120.443l-13.482 12.953 69.644 72.493-59.63 34.428 9.347 16.19 44.098-25.46c83.234 86.485 160.743 164.186 267.683 231.242-48.682-97.16-128.987-177.16-212.025-263.375l40.176-23.198-9.346-16.19-63.625 36.734-72.84-75.816zm-87.11 13.424l-17.82 5.646 20.942 66.094-53.99 13.613 4.57 18.125 38.824-9.79c25.36 79.632 50.276 151.825 99.097 222.02 2.31-80.818-23.148-155.34-48.488-234.78l37.794-9.528-4.57-18.125-55.08 13.887-21.28-67.162z"
        fill="currentColor"
      ></path>
    </g>
  </svg>
)

export const TreeSvg = (props: SvgProps) => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512" {...props}>
    <g>
      <path
        d="M348.92 15.633c-1.387-.018-2.776.02-4.168.113l-.002.006c-13.368.9-26.782 7.143-39.715 19.27-20.056-5.876-37.08-10.614-57.232-.58-37.81-11.887-75.686-13.068-104.54 19.27-42.477-10.09-87.2 9.883-76.51 58.985-47.074 14.955-56.408 78.2-.58 73.586 7.938 46.78 41.118 55.937 83.514 40.883 19.41 24.008 46.462 39.182 77.282 46.443.28 5.105.085 10.33-.566 15.68-5.807 47.77-50.79 105.31-121.367 154.696L81.12 460.723l29.16-1.354c29.003-1.347 48.05-2.39 58.935-1.55-5.818 6.555-11.317 12.37-16.28 17.297L134.04 493.88l26.26-4.417c23.887-4.017 44.442-7.94 59.927-8.363 15.484-.423 24.434 2.174 29.916 9.552l7.33 9.864 6.597-10.368c6.53-10.26 13.576-12.87 27.227-12.257 13.65.613 32.84 6.013 57.043 13.3l29.69 8.94-21.036-22.782c-8.04-8.707-15.965-18.118-23.357-27.786 2.535.115 5.228.297 8.015.596 12.14 1.3 26.887 3.978 40.67 8.067l26.127 7.75-17.145-21.184c-32.25-39.843-64.6-69.885-69.768-104.74-2.584-17.43.916-36.76 15.28-61.374 1.952-3.342 4.124-6.783 6.49-10.31 7.932-2.277 15.826-4.915 23.634-7.913 27.094 24.058 78.02 4.07 50.812-27.45 58.72-14.457 105.89-59.625 26.865-95.196 46.613-36.08 17.39-90.36-40.297-88.188-14.636-21.026-34.603-33.72-55.4-33.987zm11.277 65.488c-42.59 32.678-48.978 37.184-53.506 65.825.317 3.472.597 7.013 1.103 10.11 3.153 19.296 10.22 32.648 21.43 39.89 11.21 7.243 24.752 7.554 38.814 5.344 3.876-.61 7.86-1.446 11.91-2.397-26.82 26.337-45.555 49.373-57.742 70.253-15.75 26.986-20.6 50.827-17.404 72.385 5.283 35.632 30.606 63.305 56.864 93.556-6.317-1.147-12.557-2.146-18.21-2.752-8.907-.955-16.085-1.496-22.225-1.018-15.78-23.394-27.137-46.75-28.396-64.013l-16.875 1.23c2.246 30.812 24.037 66.155 49.786 97.565-12.35-3.28-23.554-5.657-33.69-6.112-13.696-.614-26.363 3.152-35.763 12.244-9.7-7.222-22.628-9.424-36.527-9.044-11.164.304-23.902 2.172-37.366 4.402 44.064-49.242 105.015-137.42 104.04-226.442l-16.92.186c.81 73.714-47.797 152.037-88.25 201.336-11.867-3.388-25.73-3.414-44.05-2.566 60.184-46.96 99.88-99.595 105.98-149.77 3.418-28.11-4.46-55.45-25.085-78.033-16.147-17.684-39.853-32.51-71.576-44.105 7.55-1.88 14.953-4.365 21.462-9.18 6.738-4.988 11.306-13.447 12.117-23.892 4.84 5.99 9.412 10.25 15.808 12.004 3.987 1.093 8.89.41 12.398-1.818 1.18-.75 2.055-1.72 2.987-2.65 1.008 13.36 2.204 26.116 4.996 35.543 1.305 4.41 2.77 8.54 6.917 11.938 4.147 3.4 11.522 3.424 16.02.846 2.954-1.693 5.624-4.19 8.255-7.105.53 5.72 1.776 10.502 4.068 14.624 1.406 2.527 3.53 5.005 6.594 6.473 3.065 1.467 6.72 1.527 9.586.712 5.732-1.63 9.41-5.37 13.29-10.104 8.362-10.204 17.167-27.234 25.41-49.5-1.647-26.645-3.49-39.06-35.522-58.758 25.123 13.013 47.678 20.495 89.27-7.207z"
        fill="currentColor"
      ></path>
    </g>
  </svg>
)

export const BowSvg = (props: SvgProps) => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512" {...props}>
    <g>
      <path
        d="M492.656 20.406l-118.594 56.22L413.875 86l-86.97 86.97-305.5 259.374.69.687 104.75-47.467-46.376 105.843.905.906 272.5-319.875 73.22-73.218 9.342 39.81 56.22-118.624zm-473.25.063c-1.347 23.43 5 39.947 16.563 52.218l24.093 302.28 17.562-14.874-21.72-272.438c57.975 31.954 169.096 25.165 216.907 106.72l66.625-56.564 1.22-1.218C292.74 38.666 86.01 99.716 19.406 20.47zm359.531 151.56l-1.156 1.157-57.25 67.188c82.006 47.945 75.587 159.267 107.283 218.03l-272.157-24.5-14.812 17.408 301.562 27.125c12.48 12.283 29.4 19.084 53.688 17.687-79.95-67.2-18.36-275.754-117.156-324.094z"
        fill="currentColor"
      ></path>
    </g>
  </svg>
)

export const StaffSvg = (props: SvgProps) => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512" {...props}>
    <g>
      <path
        d="M335.656 19.53c-24.51.093-48.993 5.235-71.062 15.626-22.46 10.577-43.112 34.202-58.375 62.563-15.264 28.36-25.182 61.262-27.69 88.75-7.487 82.112-51.926 155.352-159.78 252.56l-.188 21.44C89.216 403.443 139.915 346.632 176.313 290l.063.03c-9.293 32.473-22.623 63.18-43.594 87.97-31.47 35.584-69.222 71.1-114.468 106.53l-.062 8.25 25 .064h.47l1.28-1.156c24.405-16.498 48.607-31.488 72.594-41.5l.187.187-46.436 42.5 28.937.063c48.372-41.685 94.714-90.58 129.626-137 33.587-44.658 56.02-87.312 60.688-116.844-1.268-2.32-2.552-4.628-3.656-7.094-18.833-42.06-4.273-96.424 40.218-116.063 32.73-14.45 74.854-3.165 90.438 31.344.15.333.324.634.47.97 13.302 24.062 6.175 49.48-9.345 61.97-7.866 6.328-18.442 9.528-28.75 6.56-10.31-2.966-19.043-11.772-24.5-25.124l17.28-7.062c3.992 9.764 8.667 13.15 12.375 14.22 3.708 1.066 7.767.148 11.875-3.158 8.216-6.61 14.282-21.91 4.406-39.03l-.28-.47-.22-.5c-10.7-24.82-41.96-33.333-66.22-22.625-34.063 15.037-45.594 58.052-30.686 91.345 20.527 45.846 77.97 61.177 122.375 40.875 60.157-27.5 80.13-103.328 53.094-161.813-24.737-53.503-81.41-82.484-138.908-83.843-1.633-.04-3.272-.07-4.906-.063zm-25.75 26.72c3.238.035 6.363.348 9.406.906 10.343 1.898 19.946 6.753 29.032 13.25-30.623-5.437-58.324 4.612-80.78 24.782-22.44 20.152-39.16 50.59-45.783 84.718-4.655-11.358-7.166-21.462-6.686-31.72.296-6.343 1.715-12.956 4.78-20.217 9.094-18.016 21.032-33.946 35.22-46.69 7.824-7.026 16.39-13.07 25.53-17.905 10.932-5.212 20.522-7.22 29.282-7.125zm122.938 62.313c22.583 13.167 34.365 41.86 32.937 70.656-.564 11.395-3.466 22.975-8.905 33.624-12.48 18.937-35.53 25.51-49.97 20.875l-.092-.25c27.943-10.365 39.18-32.377 40.312-55.19.124-2.5.115-4.994-.03-7.468 1.447-13.31-.412-28.793-5.47-43.437-2.244-6.496-5.15-12.89-8.844-18.72l.064-.093zm-135.563 1.312c-20.97 19.342-29.406 35.252-33.25 51.25-3.848 16.023-2.788 32.84-2.905 52.875-.14 23.79-2.56 51.542-18.438 85.688-.005.012-.025.018-.03.03-21.095 26.753-45.276 52.25-68.907 67.376l-.063-.03c64.195-71.545 68.527-114.792 68.75-153.19.112-19.197-1.253-37.594 3.438-57.124.57-2.37 1.233-4.742 2-7.125h.03c8.098-17.036 16.572-26.058 25.47-31.563 7.18-4.44 15.035-6.697 23.906-8.187z"
        fill="currentColor"
      ></path>
    </g>
  </svg>
)

export const SwordSvg = (props: SvgProps) => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512" {...props}>
    <g>
      <path
        d="M256 25c-13.926 0-31.544 1.105-45.613 5.2-14.07 4.094-23.213 10.325-25.662 20.007-1.661 6.566.726 15.172 7.03 24.953 6.306 9.782 16.126 20.111 26.401 29.264 16.976 15.121 32.104 25.063 37.844 28.752 5.74-3.689 20.868-13.631 37.844-28.752 10.275-9.153 20.095-19.482 26.4-29.264 6.305-9.781 8.692-18.387 7.031-24.953-2.449-9.682-11.592-15.913-25.662-20.008C287.543 26.105 269.926 25 256 25zm-39 102.027v12.758l39 32.5 39-32.5v-12.758c-18.142 14.699-34.277 24.633-34.277 24.633L256 154.572l-4.723-2.912s-16.135-9.934-34.277-24.633zm0 36.188v41.57L241.941 184zm78 0L270.059 184 295 204.785zm-39 32.5l-39 32.5V231h19.273l13.364-13.363L256 211.27 275.729 231H295v-2.785zm175.771 24.783c-15.255 13.207-31.532 20.581-48.66 24.348-19.619 4.314-40.22 4.227-63.14 4.154h-26.244l14 14H384v18h-74.904l-8.4 14H352c31.07 0 60.695 13.027 79.646 28.627L483.273 272zm-351.552.01L28.727 272l51.627 51.627C99.305 308.027 128.93 295 160 295h51.305l-8.4-14H128v-18h76.273l14-14H192c-24 0-44.575.091-63.953-4.215-16.904-3.756-32.736-11.132-47.828-24.277zM256 236.727l-36.668 36.668L256 334.508l36.668-61.113zM201 313v180h46V354.492L222.105 313zm88.895 0L265 354.492V493h46V313z"
        fill="currentColor"
      ></path>
    </g>
  </svg>
)

export const HelpCircleSvg = (props: SvgProps) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="24"
    height="24"
    {...props}
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="2"
    strokeLinecap="round"
    strokeLinejoin="round"
  >
    <circle cx="12" cy="12" r="10"></circle>
    <path d="M9.09 9a3 3 0 0 1 5.83 1c0 2-3 3-3 3"></path>
    <line x1="12" y1="17" x2="12.01" y2="17"></line>
  </svg>
)

export const LinkSvg = (props: SvgProps) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="24"
    height="24"
    {...props}
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="2"
    strokeLinecap="round"
    strokeLinejoin="round"
  >
    <path d="M10 13a5 5 0 0 0 7.54.54l3-3a5 5 0 0 0-7.07-7.07l-1.72 1.71"></path>
    <path d="M14 11a5 5 0 0 0-7.54-.54l-3 3a5 5 0 0 0 7.07 7.07l1.71-1.71"></path>
  </svg>
)

export const EyeSvg = (props: SvgProps) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="24"
    height="24"
    {...props}
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="2"
    strokeLinecap="round"
    strokeLinejoin="round"
  >
    <path d="M1 12s4-8 11-8 11 8 11 8-4 8-11 8-11-8-11-8z"></path>
    <circle cx="12" cy="12" r="3"></circle>
  </svg>
)

export const EyeOffSvg = (props: SvgProps) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      {...props}
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    >
      <path d="M17.94 17.94A10.07 10.07 0 0 1 12 20c-7 0-11-8-11-8a18.45 18.45 0 0 1 5.06-5.94M9.9 4.24A9.12 9.12 0 0 1 12 4c7 0 11 8 11 8a18.5 18.5 0 0 1-2.16 3.19m-6.72-1.07a3 3 0 1 1-4.24-4.24"></path>
      <line x1="1" y1="1" x2="23" y2="23"></line>
    </svg>
  )
}

export const CodeSvg = (props: SvgProps) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="24"
    height="24"
    {...props}
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="2"
    strokeLinecap="round"
    strokeLinejoin="round"
  >
    <polyline points="16 18 22 12 16 6"></polyline>
    <polyline points="8 6 2 12 8 18"></polyline>
  </svg>
)

export const ExternalLinkSvg = (props: SvgProps) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="24"
    height="24"
    {...props}
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="2"
    strokeLinecap="round"
    strokeLinejoin="round"
  >
    <path d="M18 13v6a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V8a2 2 0 0 1 2-2h6"></path>
    <polyline points="15 3 21 3 21 9"></polyline>
    <line x1="10" y1="14" x2="21" y2="3"></line>
  </svg>
)

export const DrawRectangleSvg = (props: SvgProps) => (
  <svg
    width="24"
    height="24"
    {...props}
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="2"
    strokeLinecap="round"
    strokeLinejoin="round"
  >
    <path d="M3.42856 6V18" />
    <path d="M20.5714 6V18" />
    <circle cx="20.5714" cy="3.42857" r="2.42857" />
    <circle cx="3.42857" cy="3.42857" r="2.42857" />
    <circle cx="3.42857" cy="20.5714" r="2.42857" />
    <circle cx="20.5714" cy="20.5714" r="2.42857" />
    <path d="M6 3.42857L18 3.42857" />
    <path d="M6.65353 20.5714L18 20.5714" />
  </svg>
)

export const DrawShapeSvg = (props: SvgProps) => (
  <svg
    width="24"
    height="25"
    {...props}
    viewBox="0 0 24 25"
    fill="none"
    stroke="currentColor"
    strokeWidth="2"
    strokeLinecap="round"
    strokeLinejoin="round"
  >
    <path d="M3.5 6L6.5 18" />
    <circle cx="20.6896" cy="8.13793" r="2.31034" />
    <circle cx="3.31034" cy="3.31034" r="2.31034" />
    <circle cx="7.13789" cy="20.7241" r="2.31034" />
    <path d="M5.79312 3.31035L18.3448 7.24138" />
  </svg>
)

export const MetaSvg = (props: SvgProps) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="24"
    height="24"
    {...props}
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="2"
    strokeLinecap="round"
    strokeLinejoin="round"
  >
    <path d="M18 3a3 3 0 0 0-3 3v12a3 3 0 0 0 3 3 3 3 0 0 0 3-3 3 3 0 0 0-3-3H6a3 3 0 0 0-3 3 3 3 0 0 0 3 3 3 3 0 0 0 3-3V6a3 3 0 0 0-3-3 3 3 0 0 0-3 3 3 3 0 0 0 3 3h12a3 3 0 0 0 3-3 3 3 0 0 0-3-3z"></path>
  </svg>
)

export const RefreshSvg = (props: SvgProps) => (
  <svg
    stroke="currentColor"
    fill="currentColor"
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 48 48"
    height="24"
    width="24"
    {...props}
  >
    <path d="M24 40q-6.65 0-11.325-4.675Q8 30.65 8 24q0-6.65 4.675-11.325Q17.35 8 24 8q4.25 0 7.45 1.725T37 14.45V8h3v12.7H27.3v-3h8.4q-1.9-3-4.85-4.85Q27.9 11 24 11q-5.45 0-9.225 3.775Q11 18.55 11 24q0 5.45 3.775 9.225Q18.55 37 24 37q4.15 0 7.6-2.375 3.45-2.375 4.8-6.275h3.1q-1.45 5.25-5.75 8.45Q29.45 40 24 40Z" />
  </svg>
)

export const InfoSvg = (props: SvgProps) => (
  <svg
    stroke="currentColor"
    fill="currentColor"
    xmlns="http://www.w3.org/2000/svg"
    height="24"
    width="24"
    viewBox="0 0 48 48"
    {...props}
  >
    <path d="M22.65 34h3V22h-3ZM24 18.3q.7 0 1.175-.45.475-.45.475-1.15t-.475-1.2Q24.7 15 24 15q-.7 0-1.175.5-.475.5-.475 1.2t.475 1.15q.475.45 1.175.45ZM24 44q-4.1 0-7.75-1.575-3.65-1.575-6.375-4.3-2.725-2.725-4.3-6.375Q4 28.1 4 23.95q0-4.1 1.575-7.75 1.575-3.65 4.3-6.35 2.725-2.7 6.375-4.275Q19.9 4 24.05 4q4.1 0 7.75 1.575 3.65 1.575 6.35 4.275 2.7 2.7 4.275 6.35Q44 19.85 44 24q0 4.1-1.575 7.75-1.575 3.65-4.275 6.375t-6.35 4.3Q28.15 44 24 44Zm.05-3q7.05 0 12-4.975T41 23.95q0-7.05-4.95-12T24 7q-7.05 0-12.025 4.95Q7 16.9 7 24q0 7.05 4.975 12.025Q16.95 41 24.05 41ZM24 24Z" />
  </svg>
)
